import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Home from "./components/home/home";
import Experience from "./components/experience/experience";
import Project from "./components/project/project";
import Contact from "./components/contact/contact";
import Research from "./components/research/research";
import Awards from "./components/awards/awards";
import Blog from "./components/blog/blog";
import HireMe from "./components/hireme/hireme";
import NotFound from "./components/notfound/notfound";

function App() {
  return (
    <>
      <Analytics />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/projects" element={<Project />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/research" element={<Research />} />
          <Route path="/awards" element={<Awards />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/hireme" element={<HireMe />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
